function isNotEmpty(value) {
  const reg = /^(\w+\S+)$/;
  return reg.test(value);
}

function isNumeric(value) {
  const reg = /^\d+$/;
  return !Number.isNaN(value) && reg.test(value);
}

function isEmail(value) {
  const reg = /[a-zA-Z0-9.!#$%&'*]+[@]+[a-zA-Zа-яА-Я0-9!#$%&'*]+[.]+[a-zA-Zа-яА-Я!#$%&'*]{2,6}/;
  return reg.test(value);
}

// function isNumber(value) {
//   const re = /^[0-9\b]+$/;
//   return re.test(value)
// }

function hasCorrectLength(len, value) {
  return value.length === len;
}

function isStrongPassword(value) {
  const reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^\w\s]).{8,}/;
  return reg.test(value);
}

function hasWhiteSpaces(value) {
  return !!(value && value.indexOf(' ') >= 0);
}

// function isPhoneValid(phone) {
//   const regex = /^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/;
//   return regex.test(phone);
// }

export {
  isNotEmpty,
  isNumeric,
  isEmail,
  hasCorrectLength,
  isStrongPassword,
  hasWhiteSpaces,
  // isPhoneValid,
};
